import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '@welldev-group/rcl-icon';
import './styles.scss';

const SuccessModalContent = ({ content, timeout, redirectHandler, className }) => {
  const { header, message } = content;

  const memoizedRedirectHandler = useCallback(() => {
    if (redirectHandler) {
      redirectHandler();
    }
  }, [redirectHandler]);

  useEffect(() => {
    let timer;

    if (memoizedRedirectHandler) {
      timer = setTimeout(() => {
        memoizedRedirectHandler();
      }, timeout);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [memoizedRedirectHandler, timeout]);

  return (
    <div
      className={classNames(
        'success-modal-content d-flex direction-column align-center row-gap-20',
        className,
      )}
    >
      <Icon name="check" size="medium" color="success" showBGColor={true} />
      <div className="d-flex direction-column align-center row-gap-16">
        <div className="success-modal-content__header">{header}</div>
        <div className="success-modal-content-modal__message">{message}</div>
      </div>
    </div>
  );
};

SuccessModalContent.defaultProps = {
  className: '',
  timeout: 3000,
  redirectHandler: null,
};

SuccessModalContent.propTypes = {
  content: PropTypes.shape({
    header: PropTypes.node,
    message: PropTypes.node,
  }).isRequired,
  className: PropTypes.string,
  redirectHandler: PropTypes.func,
  timeout: PropTypes.number,
};

export default SuccessModalContent;
